export default __webpack_public_path__ + "static/media/lt.5015872e.svg";